import { styled } from '@mui/material';
import clsx from 'clsx';

import { ITotalSumInputProps, LOOK } from './types';
import { NumberInputControlled } from '../Form/NumberInput';

import styles from './TotalSumInput.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

const StyledInput = styled((props: ITotalSumInputProps) => <NumberInputControlled {...props} />)(
  ({ look, disabled }) => ({
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'transparent',
      color:
        look === LOOK.SUCCESS
          ? disabled
            ? scssVariables.greys_border
            : scssVariables.green_default
          : look === LOOK.FAILED
            ? scssVariables.error
            : scssVariables.greys_border,
    },
    fieldset: {
      border: `1px solid ${
        look === LOOK.SUCCESS
          ? disabled
            ? scssVariables.greys_border
            : scssVariables.green_default
          : look === LOOK.FAILED
            ? scssVariables.error
            : scssVariables.greys_border
      }`,
    },
  }),
);

export const TotalSumInput: React.FC<ITotalSumInputProps> = ({
  disabled,
  className,
  decimalScale = 2,
  ...restProps
}) => {
  return (
    <StyledInput
      {...restProps}
      disabled={disabled}
      className={clsx(styles.summaryTextfield, { [styles.disabled]: disabled }, className)}
      allowNegative={true}
      decimalScale={decimalScale}
    />
  );
};
